import hero_img from "../../../assets/images/hero/hero_img.webp";
import hero_img_mob from "../../../assets/images/hero/hero_img_mob.webp";

export const Heading = "Just Fresh. All Nature. No Nasty.";
export const SubHeading =
  "Get farm fresh fruits and vegetables delivered straight to your doorstep, at the click of a button.";
export const HeroImg = hero_img;
export const HeroImgMob = hero_img_mob;
